export const EsipProducts = [
    { title: "CNC", value: "NRML", rank: 1 },
    { title: "NRML", value: "MIS", rank: 2 },
];
export const EsipFrequency = [
    { title: "DAILY", value: "DAILY", rank: 1 },
    { title: "WEEKLY", value: "WEEKLY", rank: 2 },
    { title: "MONTHLY", value: "MONTHLY", rank: 3 },
];
export const EsipValidity = [
    { title: "Day", value: "Day", rank: 1 },
    { title: "IOC", value: "IOC", rank: 2 },
];
export const orderList = [
    { title: "Action", value: "Buy" },
    { title: "Product type", value: "F&O (NRML)" },
    { title: "Order type", value: "Market" },
    { title: "No of Lots", value: "2 (Qty: 100)" },
    { title: "Margin required", value: "14,806.75" },
    { title: "Available", value: "5,000.00" },
];
